import {
  Button,
  DialogContent,
  DialogHeader,
  Dialogß,
} from '@otter-ai/den-components';
import {
  CustomTemplateInteraction,
  CustomTemplateLimitModalInteractionEvent,
  type Screen,
  trackEvent,
  type UpgradePlanType,
} from '@otter-ai/telemetry';
import { useUpgradeDetails } from '@/shared/hooks/useUpgradeDetails';
import { useWorkspace } from '@/shared/hooks/useWorkspace';

type CustomTemplatePaywallProps = {
  onClose: () => void;
  screen: Screen;
};

export function CustomTemplatePaywall(props: CustomTemplatePaywallProps) {
  const { onClose, screen } = props;
  const {
    subscription,
    upgradeHref,
    upgradeButtonText,
    upgradePlanText,
    userCanUpgrade,
    isWorkspaceAdmin,
    upgradePlan,
  } = useUpgradeDetails();

  const { workspace } = useWorkspace();

  const triggerEventAndClose = ({
    interactionType,
  }: {
    interactionType: CustomTemplateInteraction;
  }) => {
    trackEvent(
      CustomTemplateLimitModalInteractionEvent({
        CustomTemplateInteraction: interactionType,
        IsAdmin: isWorkspaceAdmin,
        UpgradePlanType: upgradePlan as UpgradePlanType,
        QuotaDisplayed: subscription?.meeting_types?.quota,
        Screen: screen,
      }),
    );
    onClose();
  };

  return (
    <Dialogß
      size="sm"
      data-testid="custom-template-paywall"
      Header={<DialogHeader title="Custom template usage limit reached" />}
      onOpenChange={() =>
        triggerEventAndClose({
          interactionType: CustomTemplateInteraction.Close,
        })
      }
      Footer={
        userCanUpgrade && !workspace?.settings?.sales_assisted ? (
          <>
            <Button
              data-testid="custom-template-paywall-maybe-later-button"
              onClick={() =>
                triggerEventAndClose({
                  interactionType: CustomTemplateInteraction.Secondary,
                })
              }
              variant="outlineNeutral"
              version="legacy"
            >
              Maybe later
            </Button>
            <Button asChild>
              {/* TODO: replace with <Link> when upgradeHref is within Next.js */}
              <a
                data-testid="custom-template-paywall-upgrade-button"
                href={upgradeHref}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  triggerEventAndClose({
                    interactionType: CustomTemplateInteraction.Primary,
                  })
                }
              >
                {upgradeButtonText}
              </a>
            </Button>
          </>
        ) : (
          <Button
            data-testid="custom-template-paywall-ok-button"
            onClick={() =>
              triggerEventAndClose({
                interactionType: CustomTemplateInteraction.Primary,
              })
            }
          >
            Okay
          </Button>
        )
      }
    >
      <DialogContent>
        <div>
          You've reached your limit of
          <span className="font-semibold">
            {' '}
            {subscription?.meeting_types?.quota}{' '}
          </span>
          custom template applications for this workspace. Upgrade to
          <span className="font-semibold"> {upgradePlanText} </span> to unlock
          more.{!userCanUpgrade && ' The Workspace admin has been notified.'}
        </div>
      </DialogContent>
    </Dialogß>
  );
}
